import { render, staticRenderFns } from "./index-cfds.vue?vue&type=template&id=2d8667db&scoped=true"
import script from "./index-cfds.vue?vue&type=script&lang=js"
export * from "./index-cfds.vue?vue&type=script&lang=js"
import style0 from "./index-cfds.vue?vue&type=style&index=0&id=2d8667db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8667db",
  null
  
)

export default component.exports